(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("immutable"));
	else if(typeof define === 'function' && define.amd)
		define("NetlifyCmsLibAuth", ["immutable"], factory);
	else if(typeof exports === 'object')
		exports["NetlifyCmsLibAuth"] = factory(require("immutable"));
	else
		root["NetlifyCmsLibAuth"] = factory(root["NetlifyCmsDefaultExports"]["Immutable"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__10__) {
return 